import React from 'react';
import s from './ToneSlider.module.css';
import Slider from '../../../../shared/ui/slider/Slider';

interface ToneSliderProps {
    tone: string;
    value: number;
    negativeLabel: string;
    positiveLabel: string;
    onChange: (value: number) => void;
}

const ToneSlider: React.FC<ToneSliderProps> = ({
    tone,
    value,
    negativeLabel,
    positiveLabel,
    onChange,
}) => {
    const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

    return (
        <div className={s.slider_container}>
            <div className={s.track_wrapper}>
                <Slider value={value} onChange={onChange} min={-1} max={1} step={1} />
            </div>
            <div className={s.labels_container}>
                <span className={s.label_left}>{capitalizeFirstLetter(negativeLabel)}</span>
                <span className={s.label_center}>Neutral</span>
                <span className={s.label_right}>{capitalizeFirstLetter(positiveLabel)}</span>
            </div>
        </div>
    );
};

export default ToneSlider;
